var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconActiveModerate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9258 21.1075C15.0319 20.1541 20 17.2094 20 10.6411V6.67298C20 5.55507 20 4.99528 19.7822 4.56787C19.5905 4.19155 19.2837 3.88581 18.9074 3.69406C18.4796 3.47607 17.9203 3.47607 16.8002 3.47607H7.2002C6.08009 3.47607 5.51962 3.47607 5.0918 3.69406C4.71547 3.88581 4.40973 4.19155 4.21799 4.56787C4 4.99569 4 5.55616 4 6.67627V10.6411C4 17.2094 8.9678 20.1541 11.074 21.1075C11.2972 21.2085 11.4094 21.259 11.6621 21.3024C11.8215 21.3297 12.1795 21.3297 12.3389 21.3024C12.5906 21.2591 12.7016 21.2089 12.9231 21.1086L12.9258 21.1075Z",
    fill: "#028383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11.9761L10.5481 14.2742L15.1438 9.67798",
    stroke: "white",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActiveModerate);
export default __webpack_public_path__ + "static/media/iconActiveModerate.95718093f6afb556bc36af3779f3fefb.svg";
export { ForwardRef as ReactComponent };